import React, { useState } from "react";
import PropTypes from "prop-types";

import { DownloadButtonsContainer, BackLink } from "./styles";
import DownloadButton from "./DownloadButton";
import ChangeSize from "./ChangeSize";
import DownloadMessage from "core/DownloadMessage";
import AttributionPublic from "core/AttributionPublic";
import AttributionBasic from "core/AttributionBasic";

import useIconDownloadSize from "frontend/hooks/useIconDownloadSize";
import { useViewport } from "js/hooks/useViewport";

import breakpoints from "core/breakpoints";
import { DOWNLOAD_TYPES } from "icons/helpers";

const IconDetailDownload = ({
    icon,
    onBack,
    isPublic = false,
    isBasic = false,
    isPro = false,
    isPurchased = false // if coming from the checkout page
}) => {
    const [downloadSize, setDownloadSize] = useIconDownloadSize({ isBasic });

    const { browserWidth } = useViewport();
    const onMobile = browserWidth < breakpoints.tablet.px;

    let downloadMessage, attributionMessage, changeSize, backLink;

    if (isPublic || isBasic || isPurchased) {
        downloadMessage = (
            <DownloadMessage
                message={isPro ? "Welcome to NounPro!" : undefined}
                isPublicDomain={isPublic}
                icon={icon}
            />
        );
    }

    if (isBasic) {
        attributionMessage = (
            <AttributionBasic
                type="icon"
                title={icon.title}
                creator={icon.creator.name}
            />
        );
    } else if (isPublic) {
        attributionMessage = <AttributionPublic type="icon" />;
    }

    if (!isBasic && !onMobile) {
        changeSize = (
            <ChangeSize
                downloadSize={downloadSize}
                setDownloadSize={setDownloadSize}
            />
        );
    }

    if (isBasic) {
        backLink = (
            <BackLink onClick={onBack}>Back to all purchase options</BackLink>
        );
    }

    return (
        <>
            {downloadMessage}
            {attributionMessage}
            <DownloadButtonsContainer>
                {DOWNLOAD_TYPES.map(downloadType => (
                    <DownloadButton
                        key={downloadType}
                        downloadType={downloadType}
                        downloadSize={downloadSize}
                        icon={icon}
                    />
                ))}
            </DownloadButtonsContainer>
            {changeSize}
            {backLink}
        </>
    );
};

IconDetailDownload.propTypes = {
    icon: PropTypes.object.isRequired,
    onBack: PropTypes.func,
    isPublic: PropTypes.bool,
    isBasic: PropTypes.bool,
    isPro: PropTypes.bool,
    isPurchased: PropTypes.bool
};

export default IconDetailDownload;
